<template>
    <textarea class="input" :name="name" :placeholder="placeholder"
              @keyup="update"
              @change="update"
              @blur="$emit('blur', $event)"
              :class="attributes && attributes.class ?  attributes.class :  ''"
              :style="attributes && attributes.style ? attributes.style : ''"
              v-html="inputVal"
    ></textarea>
</template>

<script>
export default {
    props: [
        'label',
        'name',
        'type',
        'value',
        'placeholder',
        'attributes',
        'modelValue',
    ],
    computed: {
        inputVal() {
            return this.modelValue || this.value || '';
        },
    },
    methods: {
        update($event) {
            this.$emit('update:modelValue', $event.target.value);
        },
    }
}
</script>
